<fieldset class="m-0 border-0 p-0" aria-label="Editor de conteúdo">
<p-editor
  [formControl]="form.controls.editorContent"
  styleClass="course-rich-text-editor"
>
  <ng-template #header>
    <span class="ql-formats">
      <button type="button" class="ql-undo" aria-label="Desfazer">
        <svg viewBox="0 0 18 18"><polygon class="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10"></polygon><path class="ql-stroke" d="M4,12 L4,5.5 C4,4.119 5.119,3 6.5,3 L14,3"></path><polyline class="ql-stroke" points="12 5 14 3 12 1"></polyline></svg>
      </button>
      <button type="button" class="ql-redo" aria-label="Refazer">
        <svg viewBox="0 0 18 18"><polygon class="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10"></polygon><path class="ql-stroke" d="M14,12 L14,5.5 C14,4.119 12.881,3 11.5,3 L4,3"></path><polyline class="ql-stroke" points="6 5 4 3 6 1"></polyline></svg>
      </button>
    </span>

    <span class="ql-formats">
      <select class="ql-header" aria-label="Tipo de texto">
        <option selected></option>
        <option value="1">Título 1</option>
        <option value="2">Título 2</option>
        <option value="3">Título 3</option>
      </select>
    </span>

    <span class="ql-formats">
      <button type="button" class="ql-bold" aria-label="Negrito"></button>
      <button type="button" class="ql-italic" aria-label="Itálico"></button>
      <button type="button" class="ql-underline" aria-label="Sublinhado"></button>
      <button type="button" class="ql-strike" aria-label="Tachado"></button>
      <button type="button" class="ql-clean" aria-label="Limpar formatação"></button>
    </span>

    <span class="ql-formats">
      <button type="button" class="ql-code-block" aria-label="Bloco de código"></button>
      <button type="button" class="ql-list" value="bullet" aria-label="Lista não ordenada"></button>
      <button type="button" class="ql-list" value="ordered" aria-label="Lista ordenada"></button>
      <button type="button" class="ql-link" aria-label="Inserir link"></button>
      <button type="button" class="ql-image" aria-label="Inserir imagem"></button>
      <button type="button" class="ql-blockquote" aria-label="Citação"></button>
    </span>
  </ng-template>
</p-editor>
</fieldset>
